export const SPORTS_LIVE_NOW_CATEGORY_ID = "LIVE_NOW";
export const SPORTS_LIVE_NOW_CATEGORY_NAME = "LIVE NOW";
export const SPORTS_LIVE_NOW_STATUS = "live";
